export function passwordsMatch(password: string | null | undefined, confirmation: string | null | undefined): boolean {
  return password === confirmation;
}
